require('./style.less');

/* Start as POC -- some similarities to graphicStamps */

var DrawablePageNoteView = require('../drawableNote'),
    StampSelectorView = require('./textStampSelector/view'),
    VariableInputsView = require('./variableInputs/view'),
    ExistingTokensView = require('./existingTokens/view'),
    fvChannel = require('glRadio').channel('FV'),
    Picker = require('../../../../../plugin/vendor/bundle/vanilla-picker/bundle.js'),
    Util = require('../../../../FV/util'),
    getContrastYIQ = Util.getContrastYIQ,
    hexToRgba = Util.hexToRgba;

/*
* TODO:
* - really need refactor to make regions
* Certainly areas to look at with detached dom nodes - memory leaks here ( regions would help
* */
module.exports = DrawablePageNoteView.extend({

    initialize: function() {

        DrawablePageNoteView.prototype.initialize.apply(this, arguments);

        this.stampSelectView = null;
        //this.textPreviewView = null; -- for now not a value ... we just update
        this.variableInputsView = null;
        this.chosenFontSizeSelector = null;
        this.chosenFontSelector = null;
        this.existingTokensView = null;
        this.userChangedSubjectInput = false; // ( only applies if new ) -- could logic on uiModel but larger refactor with saving, etc ( also in graphic stamp )
        this.colorPicker = null;

    },

    modelEvents: _.extend( {}, DrawablePageNoteView.prototype.modelEvents, {

        'colorPicker:toggleEnabled': '_toggleEnabledColorPicker'  // This is really from consult group change

    }),

    // TODO: maybe combo fontSize, generatedText and font
    uiModelEvents: _.extend( {}, DrawablePageNoteView.prototype.uiModelEvents, {

        'change:selectedStamp':     'stampChanged',
        'change:generatedText ':    'generatedTextChange',
        'change:fontSize':          'generatedTextChange',
        'change:font':              'generatedTextChange',
        'change:stampPlaced':       '_updateStampReady',
        'change:textColor ':        '_updateTextColor',
        'change:textOpacity':        '_updateTextColor'

    }),

    ui: _.extend( {}, DrawablePageNoteView.prototype.ui, {

        stampSelectPlaceHolder:     '[data-stamp-select-holder]',
        templateDiv:                '.text-stamp-template',
        previewViewWrDiv:           '.text-stamp-preview-wr',
        inputsViewWr:               '.text-stamp-variables-wr',
        variableInputField:         '.txt-stamp-variable-input',  // in the inputs view but catch from here ... easier ..
        fontSizeSelect:             '.text-stamp-font-size-select',
        fontSelect:                 '.text-stamp-font-select',
        fontSelectWr:               '.ts-font-select-wr',
        existingTemplateSelectedIndicator: '.text-stamp-note-template-selected-indicator',
        existingTokensWrDiv:        '.existing-tokens-wr',
        stampReadyIndicator:        '.ts-stamp-ready-ind',
        colorPickerParent:          '.ts-cp-parent',
        opacitySlider:              '.ts-opacity-slider'

    }),

    events: function() {

        var evts =  _.extend( {}, DrawablePageNoteView.prototype.events, {
            'input @ui.variableInputField':     'variableInputBoxChange', // should these be reset when the stamp changes> -- doesn't seem to matter ( can revisit if issue )
            'input @ui.noteSubject':            'userChangedNoteSubject'
        });

        if ( !fvChannel.request('settings').isIE ) {

            _.extend( evts, {
                'input @ui.opacitySlider':  'textOpacityChange' // not working IE
            });
        }
        else {

            _.extend( evts, {
                'change @ui.opacitySlider': 'textOpacityChange'  // change works same as input browser other than IE
            });

        }

        return evts;

    },

    templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {

        isTextStamp: function () {
            return true;
        },

        fontSizes: function() {
            return this.note.uiModel.getFontSizesToPopulateDropdown();
        },

        fonts: function() {
            return this.note.uiModel.getFontsToPopulateDropdown();
        }

    }),

    // Shared code now with graphicStamp ....

    onRender: function() {

        DrawablePageNoteView.prototype.onRender.apply(this, arguments);

        this._createStampSelectView();

        // Maybe after show to go with stamp selector ... would like refactor of all to my regions
        this.stampChanged();
        this._createFontPicker();
        this._createFontColorPicker();
        this._setColorPickerColor();
        this._toggleEnabledColorPicker(); // destroys ( so can't be in create )

        this._updateOpacitySlider();

    },

    /* Direct Copy */
    // TODO: change all note views to Marionette Layout Views ...
    onShow: function() {

        // currently 'super' doesn't have onShow method but call in case it ever does
        var superOnShow = DrawablePageNoteView.prototype.onShow;
        superOnShow && superOnShow.apply( this, arguments );

        // must be in DOM for width to be calc'd according to size ( on toggle active note it still may be hidden however ) - so doesn't matter
        this._createFontSizePicker();

        // pass down the on show method to the child view
        // this should be a layout/region so we could hook into the events but dont want to break what exist
        // a better refactor would be to update to MUCH newer version of Marionette, where I believe all views inherit this functionality
        this.stampSelectView.triggerMethod('show');

    },

    /* --- Kind of an entry point --- */
    stampChanged: function() {

        this._createTemplatePreview();
        this._createTextPreviewView();
        this._createVariableInputsView();
        this.createExistingTokensView();
        this._updateStampReady();

        var selectedStamp =  this.uiModel.get('selectedStamp'),
            selectedStampIsDerivedFromPageNote =
            this.uiModel.get('selectedStamp') && this.uiModel.get('selectedStamp').isDerivedFromPageNote();

        this.ui.existingTemplateSelectedIndicator
            .toggleClass( 'active', selectedStampIsDerivedFromPageNote )
            .attr( 'title', selectedStampIsDerivedFromPageNote ? 'Selected stamp is that chosen when note was created.' : '' );


        if ( this.model.isNew() && !this.userChangedSubjectInput ) {
            this.ui.noteSubject.val( selectedStamp.get('subject') );
        }


    },

    userChangedNoteSubject: function() {

        this.model.isNew() && (this.userChangedSubjectInput = true);

    },

    /* TODO: new name -- now not just generated text -- font, font-size */
    generatedTextChange: function() {

        this._createTextPreviewView();
        //this._createVariableInputsView(); -- don't need to re-render on every kevpress
        this._updateStampReady();

        this._updateFontPickerCss();

    },

    _createStampSelectView: function() {

        this.stampSelectView && this.stampSelectView.destroy();

        var userStamps = fvChannel.request('user').getTextStamps(),
            initialStamp = this.uiModel.get('selectedStamp');

        this.stampSelectView = new StampSelectorView({
            userStamps: userStamps,
            initialStamp: initialStamp,
            onChange: function( stampId ) {

                var stamp = stampId > 0
                    ? userStamps.get( stampId )
                    : initialStamp;

                this.uiModel.setSelectedStamp( stamp );

            }.bind( this )

        });

        this.ui.stampSelectPlaceHolder.replaceWith( this.stampSelectView.render().el );

    },

    /**
     * Need to update from chosen -- it is limited -- below is one time hack to allow input of text not in the options
     * without a fork; and this lib doesn't allow monkey patch.
     * https://stackoverflow.com/questions/18706735/adding-text-other-than-the-selected-text-options-to-the-select-with-the-chosen-p
     * prob should make this a separate view
     */
    _createFontSizePicker: function() {

        this.chosenFontSizeSelector = this.ui.fontSizeSelect

            .val( this.uiModel.get('fontSize') )

            .chosen({
                width: '65px', // define it here, could be hidden on active note change
                no_results_text: 'Press enter to add:'
            }).on( 'change', _.bind( function() {

                this.uiModel.set( 'fontSize', parseFloat( this.ui.fontSizeSelect.val() ) ); // this will trigger change

            }, this ) )

            .data( 'chosen' );

        //
        // var existingKeyDown = $._data( this.ui.fontSizeSelect.data('chosen').search_field.get(0) , "events").keydown[0].handler;
        // keyup comes after keydown; forked chosen we are using also prevents default on keydown of enter


        /**
         * Exist FV bundle keydown patch already looks for the enter key on keydown ---
         * this should work b/c keyup comes after.
         */
        this.chosenFontSizeSelector.search_field.on( 'keyup', _.bind( function(e)  {

            var inputValue = this.chosenFontSizeSelector.search_field.val();
            var inputValueIsNumeric = validateFreeFontSizeInput(inputValue);
            var $noResultsMenuItem = this.chosenFontSizeSelector.dropdown.find('li.no-results');

            $noResultsMenuItem.removeClass('hide');

            if ( !inputValueIsNumeric ) {
                $noResultsMenuItem.addClass('hide');
                return;
            }

            var select = this.ui.fontSizeSelect;

            if ( e.which === 13 && $noResultsMenuItem.length > 0  ) // $noResultsMenuItem.addClass('hide');
            {
                var option = $('<option>').val( inputValue ).text( inputValue );
                select.prepend( option );
                select.find( option ).prop('selected', true);

                // Could sort but I don't think we need to
                select
                    .trigger('chosen:close')
                    .trigger('chosen:updated')
                    .trigger('change');

            }

            function validateFreeFontSizeInput(input) {
                if ( isNaN(input) )
                    return false;

                return true;
            }

        }, this));

    },

    _createFontPicker: function() {

        this.chosenFontSelector = this.ui.fontSelect
            .val( this.uiModel.get('font') )
            .chosen({
                width: '100%'
            }).on( 'change', function() {

                this.uiModel.set( 'font', this.ui.fontSelect.val() );

            }.bind( this) );

        this._updateFontPickerCss();

    },

    _updateFontPickerCss: function() {
        this.ui.fontSelectWr.css({ 'font-family': this.uiModel.get('font') });
    },

    /**
     * This should now be a sub-view
     * Was going to handle the text opacity but can't do that:
     * - if derived color rule applies, we can't disable this picker as well
     * - anyway, ran into trouble with the plugin because the alpha selector didn't work horizontally
     * In the future, if we have backgrounds, the opacity would presumably apply to the entire shape.
     */
    _createFontColorPicker: function() {

        if ( this.colorPicker ) {
            return;
        }

        var uiModel = this.uiModel;

        this.colorPicker = new Picker({
            parent:  this.ui.colorPickerParent[0],
            color:  uiModel.getTextColor(),
            editorFormat: 'hex', // can't be this if want to track alpha events ( but now we need separate controls )
            editor: false,
            alpha: false,
            onChange: function( color ) {
                //uiModel.setTextColorAndOpacity(  color.printHex(), color._rgba[3] ); -- if used for alpha
                uiModel.setTextColor( color.printHex() );
            }

        });

    },

    _setColorPickerColor: function() {

        this.ui.colorPickerParent.css({
            'background-color': this.uiModel.getTextColor()
        } );
    },

    textOpacityChange: function( e ) {

        this.uiModel.setTextOpacity( parseFloat(e.target.value) / 100 );

    },

    _updateOpacitySlider: function( ) {

        this.ui.opacitySlider.val( this.uiModel.getTextOpacity() * 100 );

    },

    _updateTextColor: function() {

        this._setColorPickerColor();
        this._createTextPreviewView(); // could make more efficient ... with only a color change ...
    },

    /**
     * Copied from the old color picker for the color rules.... also sets the title of the color picker.
     * Now extra logic for when 'expanded'.
     */
    _toggleEnabledColorPicker: function() {

        var colorRuleDisabledReason = this.model.disableColorPickerDueToColorRules( );
        var isDisabledDueToColorRule = colorRuleDisabledReason !== null;
        var isExpanded = this.uiModel.get('expanded');
        var disable = colorRuleDisabledReason !== null || isExpanded;

        // Destroy or create -> there isn't a 'disable'
        if ( disable ) {
            this._destroyColorPicker();
        }
        else {
            this._createFontColorPicker();
        }

        this.ui.colorPickerParent
            .toggleClass( 'disabled', disable )
            .attr( 'title', isDisabledDueToColorRule
                ? this._getTitleAttrForColorPicker( disable, colorRuleDisabledReason )
                : 'Color'
            );

        this._updateTextColor();

    },

    _getTitleAttrForColorPicker: function( isDisabled, disabledReason ) {

        var ORIGINAL_TITLE = 'Color';

        var title = ORIGINAL_TITLE;

        if ( isDisabled ) {
            title += ' (disabled):\n' + disabledReason;
        }

        return title;

    },

    /* -- CP */

    // TODO: TEMP now with just a text area
    // TODO: toggle white space ???
    _createTemplatePreview: function() {

        this.ui.templateDiv.html( this.uiModel.getSelectedStamp().getText() );

    },

    _createVariableInputsView: function() {

        this.variableInputsView && this.variableInputsView.destroy(); // TODO: regions

        if ( this.uiModel.getSelectedStamp().hasVariables() ) {

            this.variableInputsView = new VariableInputsView({
                inputCollection: this.uiModel.getVariableInputs()
            });

            this.ui.inputsViewWr.append( this.variableInputsView.render().el );

        }

    },

    createExistingTokensView: function() {

       this.existingTokensView && this.existingTokensView.destroy();

        var selectedStamp = this.uiModel.getSelectedStamp();

        if ( selectedStamp.isDerivedFromPageNote() && selectedStamp.hasTokens() ) {

            this.existingTokensView = new ExistingTokensView({
                stampNoteUiModel: this.uiModel
            });

            this.ui.existingTokensWrDiv.append(this.existingTokensView.render().el);

        }

    },

    _createTextPreviewView: function() {

        var uiModel = this.uiModel,
            textColor = uiModel.getColorToApply(),
            backgroundColor =  getContrastYIQ( textColor, '#333');

        // Not doing font-size -- can lead to spacing issues
        this.ui.previewViewWrDiv
            .css({
                color: hexToRgba( textColor, uiModel.getTextOpacity() ),
                'background-color': backgroundColor,
                'font-family': uiModel.getFont()
            })
            .html( this.uiModel.getGeneratedText() );
    },

    /**
     * From change in stampPlaced or change stampReady --
     * could name more appropriately.
     * Show checkmark icon and indicator if user if ready to place a stamp ( assuming it is valid and not placed ).
     * Stamps can be placed and invalid if the user changes the input after the place the stamp.
     * If stamp is placed, never show.
     * If not, show if the inputs are valid and the stamp is ready.
     * If stamp is placed and the inputs are not valid, use will get a validation error msg if they try to save.
     */

    _updateStampReady: function() {

        if ( this.uiModel.get('stampPlaced') ) {

            this.ui.stampReadyIndicator.addClass( 'hide' );
            return;
        }

        this.ui.stampReadyIndicator.toggleClass( 'hide',  !this.uiModel.getInputsValid() );

    },

    /** Note: length validated in html */
    variableInputBoxChange: function(e) {

        var $input = $(e.target),
            variableKey = $input.data('key'),
            inputValue = $input.val();

        this.uiModel.updateInputVariableValue( variableKey, inputValue );

    },

    toggleExpandMode: function( uiModel, expanded ) {

        DrawablePageNoteView.prototype.toggleExpandMode.apply( this, arguments );

        this._toggleEnabledColorPicker();

    },

    _destroyColorPicker: function() {

        if ( !this.colorPicker ) {
            return;
        }

        this.colorPicker.destroy();
        this.colorPicker = null;
    },

    onBeforeDestroy: function() {

        this.stampSelectView && this.stampSelectView.destroy();
        this.variableInputsView && this.variableInputsView.destroy();
        this.existingTokensView && this.existingTokensView.destroy();

        this.ui.fontSelect.chosen('destroy').off();


        /* font-selector -- maybe want to self encapsulate */
        if ( this.chosenFontSizeSelector )
        {
            this.chosenFontSizeSelector.search_field.off(); // unsure if necessary
            this.ui.fontSizeSelect
                .chosen('destroy')
                .off();
        }

        this._destroyColorPicker();

        DrawablePageNoteView.prototype.onBeforeDestroy.apply( this, arguments );

    }


});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/textStamp/view.js
 ** module id = 323
 ** module chunks = 0
 **/